import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import FormLabel from "@material-ui/core/FormLabel";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Moment from "moment";

import {
  Mail,
  WhatsApp,
  Person,
  BusinessCenter,
  HomeWork,
  MonetizationOn,
  GpsFixed,
} from "@material-ui/icons";

import axios from "axios";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Slide from "@material-ui/core/Slide";

// SELECT
import MapDraggableMarker from "views/Maps/MapDraggableMarker";
import SuccessfulMessage from "views/dialog/SuccessfulMessageForm";

import AnotherNeeds from "views/dialog/AnotherNeeds";
import AnotherHas from "views/dialog/AnotherHas";
import AnotherWaste from "views/dialog/AnotherWaste";
import AnotherEconomicSector from "views/dialog/AnotherEconomicSector";
import AnotherOrganizationType from "views/dialog/AnotherOrganizationType";

import { cardStyle } from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

export default function FormBusinessNetworks() {
  const classes = useStyles();
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [openAlertsuccess, setOpenAlertsuccess] = useState(false);
  const [mensaje_success, setMensaje_success] = useState("");

  const [openAnotherNeeds, setopenAnotherNeeds] = useState(false);
  const [openAnotherHas, setopenAnotherHas] = useState(false);
  const [openAnotherWaste, setopenAnotherWaste] = useState(false);
  const [openAnotherOrganizationType, setopenAnotherOrganizationType] =
    useState(false);
  const [openAnotherEconomicSector, setopenAnotherEconomicSector] =
    useState(false);

  const [dataLtLgCity, setdataLtLgCity] = useState({
    lt: -0.18093079060265435,
    lg: -78.46778869628906,
  });

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    participant: "",
    representativeContact: "",
    phone: "",
    email: "",
    organizationType: [],
    organizationTypeSelected: [],
    organizationTypeID: "",
    economicSector: [],
    economicSectorSelected: [],
    economicSectorID: "",
    needs: [],
    needsSelected: [],
    needsID: [],
    needsSaveValues: [],
    has: [],
    hasSelected: [],
    hasID: [],
    hasSaveValues: [],
    wasteType: [],
    wasteTypeSelected: [],
    wasteTypesID: [],
    wasteSaveValues: [],
    dateEvent: Moment("2022-03-15 00:00:00").format("YYYY-MM-DD"),
    errorParticipant: false,
    errorRepresentativeContact: false,
    errorPhone: false,
    errorEmail: false,
    errorEconomicSector: false,
    errorOrganizationType: false,
    errorNeeds: false,
    errorHas: false,
    errorWasteType: false,
    latitude: -0.18093079060265435,
    longitude: -78.46778869628906,
    organizationTypeAnother: "",
    economicSectorAnother: "",
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setoOpenBackdrop(true);

    const data = {
      catalogs: [
        {
          detailName: "catOrganizationType",
          codeExclusion: "0",
        },
        {
          detailName: "catEconomicSector",
          codeExclusion: "0",
        },
        {
          detailName: "catNeedsHas",
          codeExclusion: "0",
        },
        {
          detailName: "catWasteType",
          codeExclusion: "0",
        },
      ],
    };

    axios
      .post(`${urlServices}catalogsDetails/getMultiplesCatalogs`, data, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          setoOpenBackdrop(false);
          setValues({
            ...values,
            organizationType: response.data.catalogs.catOrganizationType,
            economicSector: response.data.catalogs.catEconomicSector,
            needs: response.data.catalogs.catNeedsHas,
            has: response.data.catalogs.catNeedsHas,
            wasteType: response.data.catalogs.catWasteType,
          });
        },
        (error) => {
          console.log(error);
          setoOpenBackdrop(false);
        }
      );
  }, [urlServices, keyAplication]);

  const changeNeedsSelected = (e, pro) => {
    let output = [],
      outputSave = [];

    pro.map((items, i) => {
      output.push({ id: items.code, name: items.detailName });

      if (items.detailName !== "Otros") {
        outputSave.push({ id: items.code, another: "" });
      }

      return output, outputSave;
    });

    setValues({
      ...values,
      needsSaveValues: outputSave,
      needsSelected: pro,
      needsID: output,
      errorNeeds: false,
    });
  };

  const changeHasSelected = (e, pro) => {
    let output = [],
      outputSave = [];

    pro.map((items, i) => {
      output.push({ id: items.code, name: items.detailName });

      if (items.detailName !== "Otros") {
        outputSave.push({ id: items.code, another: "" });
      }

      return output, outputSave;
    });

    setValues({
      ...values,
      hasSaveValues: outputSave,
      hasSelected: pro,
      hasID: output,
      errorHas: false,
    });
  };

  const changeWasteTypeSelected = (e, pro) => {
    let output = [],
      outputSave = [];

    pro.map((items, i) => {
      output.push({ id: items.code, name: items.detailName });

      if (items.detailName !== "Otros") {
        outputSave.push({ id: items.code, another: "" });
      }

      return output, outputSave;
    });

    setValues({
      ...values,
      wasteSaveValues: outputSave,
      wasteTypeSelected: pro,
      wasteTypesID: output,
      errorWasteType: false,
    });
  };

  const changeOrganizationTypeSelected = (e, pro) => {
    if (pro !== null) {
      if (pro.detailName === "Otros") {
        setopenAnotherOrganizationType(true);
      }

      setValues({
        ...values,
        organizationTypeSelected: pro,
        organizationTypeID: pro.code,
        errorOrganizationType: false,
      });
    }
  };

  const changeEconomicSectorSelected = (e, pro) => {
    if (pro !== null) {
      if (pro.detailName === "Otros") {
        setopenAnotherEconomicSector(true);
      }

      setValues({
        ...values,
        economicSectorSelected: pro,
        economicSectorID: pro.code,
        errorEconomicSector: false,
      });
    }
  };

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorParticipant: false,
      errorRepresentativeContact: false,
      errorPhone: false,
      errorEmail: false,
    });
  };

  const getResponselt = (latitude) => {
    setValues({ ...values, latitude: latitude });
    setdataLtLgCity({
      lt: latitude,
      lg: values.longitude,
    });
  };

  const getResponselng = (longitude) => {
    setValues({ ...values, longitude: longitude });
    setdataLtLgCity({
      lt: values.latitude,
      lg: longitude,
    });
  };

  const handleClose = (event, reason) => {
    setOpenAlert(false);
  };

  const handleCloseSuccess = (event, reason) => {
    setOpenAlertsuccess(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const submitForm = (e) => {
    e.preventDefault();

    setOpenAlertsuccess(false);

    if (values.participant === "") {
      setMensaje_error("Campo Nombre del negocio es obligatorio.");
      setOpenAlert(true);
      setValues({ ...values, errorParticipant: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.representativeContact === "") {
      setMensaje_error("Campo Persona de contacto es obligatorio.");
      setOpenAlert(true);
      setValues({ ...values, errorRepresentativeContact: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.phone === "") {
      setMensaje_error("Campo Teléfono es obligatorio.");
      setOpenAlert(true);
      setValues({ ...values, errorPhone: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.email === "") {
      setMensaje_error("Campo Correo electrónico es obligatorio.");
      setOpenAlert(true);
      setValues({ ...values, errorEmail: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      setMensaje_error("El Correo electrónico no es válido!");
      setOpenAlert(true);
      setValues({ ...values, errorEmail: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.organizationTypeSelected.length === 0) {
      setMensaje_error("Seleccione un Tipo de organización.");
      setOpenAlert(true);
      setValues({ ...values, errorOrganizationType: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.economicSectorSelected.length === 0) {
      setMensaje_error("Seleccione un Sector económico.");
      setOpenAlert(true);
      setValues({ ...values, errorEconomicSector: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.needsSelected.length === 0) {
      setMensaje_error("Seleccione un recurso que Necesite.");
      setOpenAlert(true);
      setValues({ ...values, errorNeeds: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.hasSelected.length === 0) {
      setMensaje_error("Seleccione un recurso que Tengas.");
      setOpenAlert(true);
      setValues({ ...values, errorHas: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (values.wasteTypeSelected.length === 0) {
      setMensaje_error("Seleccione un Residuo.");
      setOpenAlert(true);
      setValues({ ...values, errorWasteType: true });
      setoOpenBackdrop(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setoOpenBackdrop(true);

      const data = {
        event_id: 1,
        name: values.participant,
        contact: values.representativeContact,
        phone: values.phone,
        email: values.email,
        lat: JSON.stringify(values.latitude),
        lon: JSON.stringify(values.longitude),
        organization_type_code: values.organizationTypeID,
        economic_sector_code: values.economicSectorID,
        needs: values.needsSaveValues,
        has: values.hasSaveValues,
        wastes: values.wasteSaveValues,
        organization_type_another: values.organizationTypeAnother,
        economic_sector_another: values.economicSectorAnother,
      };

      axios
        .post(`${urlServices}preRegisters`, data, {
          headers: {
            application: keyAplication,
          },
        })
        .then(
          (response) => {
            setValues({
              ...values,
              participant: "",
              representativeContact: "",
              phone: "",
              email: "",
              organizationTypeSelected: [],
              organizationTypeID: "",
              economicSectorSelected: [],
              economicSectorID: "",
              needsSelected: [],
              needsID: [],
              hasSelected: [],
              hasID: [],
              wasteTypeSelected: [],
              wasteTypesID: [],
              latitude: "",
              longitude: "",
              organizationTypeAnother: "",
              economicSectorAnother: "",
              needsSaveValues: [],
              hasSaveValues: [],
              wasteSaveValues: [],
            });

            setMensaje_success(
              "Bienvenido(a) a conecta2, usted ha sido registrado para la convocatória."
            );
            setOpenAlertsuccess(true);
            setoOpenBackdrop(false);
          },
          (error) => {
            console.log(error);
            setoOpenBackdrop(false);
          }
        );
    }
  };

  const callbackAnotherNeeds = (data) => {
    if (data !== "") {
      values.needsID.map((items, i) => {
        if (items.name === "Otros") {
          values.needsSaveValues.push({ id: items.id, another: data.another });
        }
      });
    } else {
      values.needsID.map((items, i) => {
        if (items.name === "Otros") {
          values.needsID.splice(i, 1);
          values.needsSelected.splice(i, 1);
        }
      });

      setValues({ ...values, needsSelected: values.needsSelected });
    }
  };

  const callbackAnotherHas = (data) => {
    if (data !== "") {
      values.hasID.map((items, i) => {
        if (items.name === "Otros") {
          values.hasSaveValues.push({ id: items.id, another: data.another });
        }
      });
    } else {
      values.hasID.map((items, i) => {
        if (items.name === "Otros") {
          values.hasID.splice(i, 1);
          values.hasSelected.splice(i, 1);
        }
      });

      setValues({ ...values, hasSelected: values.hasSelected });
    }
  };

  const callbackAnotherWaste = (data) => {
    if (data !== "") {
      values.wasteTypesID.map((items, i) => {
        if (items.name === "Otros") {
          values.wasteSaveValues.push({ id: items.id, another: data.another });
        }
      });
    } else {
      values.wasteTypesID.map((items, i) => {
        if (items.name === "Otros") {
          values.wasteTypesID.splice(i, 1);
          values.wasteTypeSelected.splice(i, 1);
        }
      });

      setValues({ ...values, wasteTypeSelected: values.wasteTypeSelected });
    }
  };

  const callbackAnotherEconomicSector = (data) => {
    if (data !== "") {
      setValues({
        ...values,
        economicSectorAnother: data.another,
      });
    } else {
      setValues({
        ...values,
        economicSectorSelected: null,
        economicSectorID: "",
      });
    }

    setopenAnotherEconomicSector(false);
  };

  const callbackAnotherOrganizationType = (data) => {
    if (data !== "") {
      setValues({
        ...values,
        organizationTypeAnother: data.another,
      });
    } else {
      setValues({
        ...values,
        organizationTypeSelected: null,
        organizationTypeID: "",
      });
    }

    setopenAnotherOrganizationType(false);
  };

  return (
    <Fragment>
      <Grid container spacing={3} className={classes.containerStyle}>
        <Grid item xs={12} sm={6}>
          <TextField
            variant="outlined"
            fullWidth
            disabled
            value="Reactivación económica de Quito"
            autoComplete="off"
            label="Nombre del evento"
            margin="dense"
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            variant="outlined"
            fullWidth
            disabled
            value={values.dateEvent}
            autoComplete="off"
            label="Fecha del evento"
            margin="dense"
            inputProps={{
              style: { textAlign: "center" },
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            variant="outlined"
            fullWidth
            value="Quito"
            disabled
            autoComplete="off"
            label="Ciudad del evento"
            margin="dense"
            inputProps={{
              style: { textAlign: "center" },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <b>Información básica:</b>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="participant"
            value={values.participant}
            error={values.errorParticipant}
            onChange={handleChange("participant")}
            fullWidth
            required
            autoComplete="off"
            label="Negocio o emprendimiento"
            margin="dense"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessCenter className={classes.iconStyle} />
                </InputAdornment>
              ),
            }}
            placeholder="Nombre ..."
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="representativeContact"
            value={values.representativeContact}
            error={values.errorRepresentativeContact}
            onChange={handleChange("representativeContact")}
            fullWidth
            required
            autoComplete="off"
            label="Persona de Contacto"
            margin="dense"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Person className={classes.iconStyle} />
                </InputAdornment>
              ),
            }}
            placeholder="Nombre ..."
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="phone"
            value={values.phone}
            error={values.errorPhone}
            onChange={handleChange("phone")}
            fullWidth
            required
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Teléfono"
            margin="dense"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <WhatsApp className={classes.iconStyle} />
                </InputAdornment>
              ),
              maxLength: 12,
            }}
            placeholder="0959637836"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="email"
            value={values.email}
            error={values.errorEmail}
            onChange={handleChange("email")}
            /* onInput={(e) => {
             handleValidate(e.target.value);
          }}*/
            fullWidth
            required
            autoComplete="off"
            label="Correo electrónico"
            margin="dense"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Mail className={classes.iconStyle} />
                </InputAdornment>
              ),
            }}
            placeholder="ejemplo@gmail.com"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            id="combo-box-demo"
            options={values.organizationType}
            value={values.organizationTypeSelected}
            onChange={changeOrganizationTypeSelected}
            getOptionLabel={(option) => option.detailName || ""}
            renderInput={(params) => {
              params.InputProps.startAdornment = (
                <InputAdornment position="start">
                  <HomeWork className={classes.iconStyle} />
                </InputAdornment>
              );
              return (
                <TextField
                  {...params}
                  label="Tipo de actor"
                  variant="standard"
                  error={values.errorOrganizationType}
                  placeholder="Seleccione un actor ..."
                  required
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            id="combo-box-demo"
            options={values.economicSector}
            value={values.economicSectorSelected}
            onChange={changeEconomicSectorSelected}
            getOptionLabel={(option) => option.detailName || ""}
            renderInput={(params) => {
              params.InputProps.startAdornment = (
                <InputAdornment position="start">
                  <MonetizationOn className={classes.iconStyle} />
                </InputAdornment>
              );
              return (
                <TextField
                  {...params}
                  label="Sector económico"
                  variant="standard"
                  error={values.errorEconomicSector}
                  placeholder="Seleccione un sector..."
                  required
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <b>Selección multiples:</b>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            size="small"
            multiple
            limitTags={2}
            options={values.needs}
            value={values.needsSelected}
            onChange={changeNeedsSelected}
            disableCloseOnSelect
            getOptionLabel={(option) => option.detailName || ""}
            renderOption={(option, { selected }) => {
              setopenAnotherNeeds(
                selected
                  ? option.detailName === "Otros"
                    ? true
                    : false
                  : false
              );
              return (
                <Fragment>
                  <Checkbox style={{ marginRight: 8 }} checked={selected} />
                  {option.detailName}
                </Fragment>
              );
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Recursos de valor que NECESITAS:"
                  helperText="Recursos que necesitas para mejorar tu cadena de valor."
                  error={values.errorNeeds}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            size="small"
            multiple
            limitTags={2}
            options={values.has}
            value={values.hasSelected}
            onChange={changeHasSelected}
            disableCloseOnSelect
            getOptionLabel={(option) => option.detailName || ""}
            renderOption={(option, { selected }) => {
              setopenAnotherHas(
                selected
                  ? option.detailName === "Otros"
                    ? true
                    : false
                  : false
              );
              return (
                <Fragment>
                  <Checkbox style={{ marginRight: 8 }} checked={selected} />
                  {option.detailName}
                </Fragment>
              );
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Recursos de valor que TENGO:"
                  helperText="Recursos para crear oportunidades de negocio."
                  error={values.errorHas}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            size="small"
            multiple
            limitTags={2}
            options={values.wasteType}
            value={values.wasteTypeSelected}
            onChange={changeWasteTypeSelected}
            disableCloseOnSelect
            getOptionLabel={(option) => option.detailName || ""}
            renderOption={(option, { selected }) => {
              setopenAnotherWaste(
                selected
                  ? option.detailName === "Otros"
                    ? true
                    : false
                  : false
              );
              return (
                <Fragment>
                  <Checkbox style={{ marginRight: 8 }} checked={selected} />
                  {option.detailName}
                </Fragment>
              );
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Residuos que genera tu sector:"
                  helperText="Residuos para reinsertarlos en la cadena productiva."
                  error={values.errorWasteType}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <b>Ubicación:</b>
        </Grid>
        <Grid item xs={12} md={12} className={classes.mapStyle}>
          <div className={classes.fontParagraphAlert}>
            <GpsFixed /> Habilita la ubicación de tu navegador.
          </div>
          <FormLabel component="legend">
            <div className={classes.fontParagraph}>
              Por favor, seleccione el puntero rojo y arrastre hasta la
              ubicación del negocio.
            </div>
          </FormLabel>

          <MapDraggableMarker
            callbacklt={getResponselt}
            callbacklng={getResponselng}
            dataltlg={dataLtLgCity}
          />
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 80 }}>
          <center>
            <Button
              type="submit"
              className={classes.buttonSubmit}
              onClick={submitForm}
            >
              Registrar
            </Button>
          </center>
        </Grid>
      </Grid>
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity="error"
            elevation={6}
            variant="filled"
          >
            {mensaje_error}
          </Alert>
        </Slide>
      </Snackbar>
      {openAlertsuccess ? (
        <SuccessfulMessage
          callbackFalse={handleCloseSuccess}
          callbackTrue={openAlertsuccess}
          mensaje_success={mensaje_success}
        />
      ) : (
        ""
      )}
      {openAnotherNeeds ? (
        <AnotherNeeds
          callbackValues={callbackAnotherNeeds}
          callbackTrue={openAnotherNeeds}
        />
      ) : (
        ""
      )}
      {openAnotherHas ? (
        <AnotherHas
          callbackValues={callbackAnotherHas}
          callbackTrue={openAnotherHas}
        />
      ) : (
        ""
      )}
      {openAnotherWaste ? (
        <AnotherWaste
          callbackValues={callbackAnotherWaste}
          callbackTrue={openAnotherWaste}
        />
      ) : (
        ""
      )}
      {openAnotherEconomicSector ? (
        <AnotherEconomicSector
          callbackValues={callbackAnotherEconomicSector}
          callbackTrue={openAnotherEconomicSector}
        />
      ) : (
        ""
      )}
      {openAnotherOrganizationType ? (
        <AnotherOrganizationType
          callbackValues={callbackAnotherOrganizationType}
          callbackTrue={openAnotherOrganizationType}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
}
